import { http, http_v2 } from '@api/client';
import { PaginatedResponse } from '@api/shared';
import { paramterize, pickResponse } from '@api/utils';

export function companySearch({ person_vtr_id = '' }: CompanySearchParams) {
  return http_v2.get<CompanyDetail>('/person/' + person_vtr_id + '/companies').pipe(pickResponse());
}

interface CompanyDetail {
  data: string[];
}
interface CompanySearchParams {
  person_vtr_id?: string;
}
interface NewCompanyDetail {
  person_vtr_id: string;
}
